export default class Jurisdictions {
    static options() {
        return Jurisdictions.names().map((jurisdiction) => ({label: jurisdiction, value: jurisdiction}));
    }

    static names() {
        return [
            'Buenos Aires',
            'Catamarca',
            'Chaco',
            'Chubut',
            'Capital Federal',
            'Córdoba',
            'Corrientes',
            'Entre Ríos',
            'Formosa',
            'Jujuy',
            'La Pampa',
            'La Rioja',
            'Mendoza',
            'Misiones',
            'Neuquén',
            'Río Negro',
            'Salta',
            'San Juan',
            'San Luis',
            'Santa Cruz',
            'Santa Fe',
            'Santiago del Estero',
            'Tierra del Fuego',
            'Tucumán',
        ];
    }
}
